import {
  LOGIN_SUCCESS,
  LOGIN_ERROR,
  DISMISS_MESSAGE,
  REMOVE_DEVICE_EXPIRY,
  RESET_PRODA_INFO,
  REMOVE_CERTIFICATE_EXPIRY_WARNING,
  LOGOUT
} from "../constants/auth";

const initialState = {
  loading: false,
  success: false,
  error: false,
  message: "",
  isLoggedIn: false,
  user: null
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        success: false,
        error: false,
        isLoggedIn: true,
        loading: false,
        message: "",
        user: action.payload
      };
    case LOGIN_ERROR:
      return {
        ...state,
        success: false,
        error: true,
        isLoggedIn: false,
        loading: false,
        message: action.payload
      };
    case LOGOUT:
      console.log("Logout user called");
      return {
        ...state,
        isLoggedIn: false,
        user: null,
      }
    case DISMISS_MESSAGE:
      return {
        ...state,
        success: false,
        error: false,
        message: ""
      };
    case REMOVE_DEVICE_EXPIRY:
      return {
        ...state,
        user: {
          ...state.user,
          isPRODADeviceExpiryWarning: false
        }
      };
    case RESET_PRODA_INFO:
      return {
        ...state,
        user: {
          ...state.user,
          PRODAInfo: action.payload
        }
      };
    case REMOVE_CERTIFICATE_EXPIRY_WARNING:
      return {
        ...state,
        user: {
          ...state.user,
          certificatesExpiryInfo: {
            ...state.user.certificatesExpiryInfo,
            [action.payload]: ""
          }
        }
      };
    default:
      return state;
  }
}
